import { render, staticRenderFns } from "./registry.vue?vue&type=template&id=3cdc23a1"
import script from "./registry.vue?vue&type=script&lang=js"
export * from "./registry.vue?vue&type=script&lang=js"
import style0 from "./registry.vue?vue&type=style&index=0&id=3cdc23a1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports